export const TIPOS_EMPRESA = [
  { value: "externa", label: "Externa" },
  { value: "interna", label: "Interna" },
  { value: "proveedor", label: "Proveedor" },
];

export const initialEmpresaForm = {
  nombre: "",
  ruc: "",
  telefono: "",
  email: "",
  tipo: "externa",
  activo: true,
};

